"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cSettingsSchema = void 0;
var zod_1 = require("zod");
exports.cSettingsSchema = {
    searchRules: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string().uuid(),
        label: zod_1.z.object({
            value: zod_1.z.string()
        }),
        listIdA: zod_1.z.object({
            value: zod_1.z.string().uuid()
        }),
        listIdB: zod_1.z.object({
            value: zod_1.z.array(zod_1.z.string().uuid())
        })
    }))
};
